import {
  ContainerData,
  SectionDescription,
  SectionTitle,
  TitleToggleRow
} from "./styles";
import { useEffect, useState } from "react";
import { Input } from "../../../components/inputs";
import { toast } from "react-toastify";
import { Page } from "../../../components/page-base";

import { ConfigService } from "../services";
import { useAuthContext } from "@/contexts";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

import { TokensDisplay } from "@/components/tokens";
import { ContentConditional } from "@/components/content-conditional";
import theme from "@/styles/theme";

export const Configurations: React.FC = () => {
  const [email, setEmail] = useState<string>("");
  const [webhookUrl, setWebhookUrl] = useState<string>("");
  const [webhookActive, setWebhookActive] = useState<boolean>(false);
  const [webhookToken, setWebhookToken] = useState<string>("");
  const [handleWebhookDisabled, setHandleWebhookDisabled] =
    useState<boolean>(true);

  const { user } = useAuthContext();

  useEffect(() => {
    const getConfig = async () => {
      try {
        const response = await ConfigService.getConfig();
        if (response.success && response.data) {
          const { contactEmail, webhookUrl, webhookActive, webhookToken } =
            response.data;
          setEmail(contactEmail);
          setWebhookUrl(webhookUrl);
          setWebhookActive(webhookActive);
          setWebhookToken(webhookToken);
        }
      } catch (error) {
        console.error("Erro ao buscar configuração:", error);
      }
    };

    getConfig();
  }, []);

  const handleEmailChange = (value: string) => {
    setEmail(value.toLowerCase());
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const data = await ConfigService.updateEmailConfig({
        contactEmail: email.toLocaleLowerCase()
      });
      if (data.success) {
        toast.success("Email atualizado com sucesso!");
      }
    } catch (error) {
      toast.error(
        "Erro ao atualizar email, reinicie a página e tente novamente!"
      );
      console.error("Erro ao atualizar email:", error);
    }
  };
  const handleWebHookSave = async () => {
    try {
      const data = await ConfigService.updateWebhookConfig(
        webhookUrl,
        webhookToken,
        webhookActive
      );
      if (data.success) {
        toast.success("Webhook atualizado com sucesso!");
      }
    } catch (error) {
      toast.error(
        "Erro ao atualizar webhook, reinicie a página e tente novamente!"
      );
      console.error("Erro ao atualizar webhook:", error);
    }
  };

  const handleChangeWebhook = (e: React.ChangeEvent<HTMLInputElement>) => {
    setWebhookActive(e.target.checked);
    setHandleWebhookDisabled(false);
  };

  return (
    <Page.Root>
      <Page.Header
        title="Configurações"
        key="consult"
        iconPage={<SettingsOutlinedIcon />}
      />
      <ContainerData>
        <SectionTitle>Contato</SectionTitle>
        <div>
          {user?.fullName && user?.phone && (
            <div className="flex mobile:flex-col gap-1 mt-4">
              <Input.Label
                className="mb-5 mobile:mb-1"
                disabled={true}
                label="Usuario"
                setValue={handleEmailChange}
                type="text"
                value={user.fullName}
              />
              <Input.Label
                className="mb-5 mobile:mb-1"
                label="WhatsApp"
                disabled={true}
                setValue={handleEmailChange}
                type="text"
                value={user.phone}
              />
            </div>
          )}
          <form onSubmit={handleSubmit} className="w-full">
            <Input.Label
              className="mb-5"
              label="Email para envio de consultas e demais comunicações"
              setValue={handleEmailChange}
              type="email"
              value={email}
            />
            <Page.Button label="Salvar" type="submit" />
          </form>
        </div>
      </ContainerData>

      <ContainerData disabled={!webhookActive}>
        <TitleToggleRow>
          <SectionTitle>Webhook e API</SectionTitle>
          <div className="toggle-container">
            <span>{webhookActive ? "Ativado" : "Desativado"}</span>
            <Input.Toggle
              checked={webhookActive}
              onChange={handleChangeWebhook}
              disabled={false}
              backgroundColor={
                webhookActive ? theme.colors.palete.green : "#A0A0A0"
              }
            />
          </div>
        </TitleToggleRow>
        <SectionDescription>
          Informe neste campo a URL que será chamada via webhook ao finalizar a
          consulta, de modo que o sistema envie automaticamente uma requisição
          HTTP com os resultados para o endpoint informado.
        </SectionDescription>
        <Input.Label
          label="URL do webhook"
          setValue={(value: string) => {
            setWebhookUrl(value);
            setHandleWebhookDisabled(false);
          }}
          type="text"
          value={webhookUrl}
        />
        <Input.Password
          label="Token do webhook"
          setValue={(value: string) => {
            setWebhookToken(value);
            setHandleWebhookDisabled(false);
          }}
          value={webhookToken}
        />
        <div style={{ marginTop: "2vh" }}>
          <Page.Button
            label="Salvar"
            type="button"
            onClick={handleWebHookSave}
            disabled={handleWebhookDisabled}
          />
        </div>
      </ContainerData>

      <ContentConditional.Permission permission={["owner"]}>
        <TokensDisplay entity="users" />
      </ContentConditional.Permission>
    </Page.Root>
  );
};
